const doc = [({"da":({"js":({"admin":({"tenants":({"setup":({"the_settings_were_saved":"Indstillingerne blev gemt"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;